/**=========================================================
 * Module: files-popup.js
 * FilesPopup Controller
 =========================================================*/

 App.controller('FilesPopupController',
    ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'ngDialog', 'DataService',
    function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, ngDialog, D) {
      "use strict";
      
        $scope.initialized = false;
        $scope.watchActivated = false;
        $scope.files = [];
        $scope.init = function(){  
        
            if($rootScope.user.id){
                D.query('file', { entityId: $scope.entity, field: $scope.field, type: $scope.type }).then(function(response){
                    $scope.files = response;
                })
            } else {
                if(!$scope.watchActivated){
                    $scope.watchActivated = true;
                    $rootScope.$watch('user.id', function(){
                        if(!$scope.initialized){
                            $scope.init();
                        }
                    });
                }
            }
        }
        
        $scope.init();

        $scope.showFiles = function(){
            if($scope.files.length > 0 || $scope.showIfEmpty){
                
                $scope.params = $scope
                ngDialog.open({
                        template: '/app/views/entities/file-popuplist.html',
                        className: 'ngdialog-theme-default',
                        scope: $scope,
                        cache: false
                    });
            }
        }
        
    }
    ]);